// Which questions round 0 puts, for the tile that was tapped.
//
// Read from the home payload the flow is already holding, never fetched per
// question: by the time a tile is tapped its chips are in the browser. That
// is the property that lets round 0 sit in front of the raise — an extra
// round trip here would be a spinner between the operator and help, which is
// the trade this app does not make.
//
// Which questions a tile asks, and whether an attached pod removes one, are
// the server's decisions. This picks between two sets it was handed; it does
// not compose them. Pure, so the card can be driven by a stubbed home.

import type { AlertTypeKey, OperatorHomeVM, PreRaiseQuestion } from '@/api/andon/types';

/**
 * The set for one tile, from a home payload.
 *
 * Absent only when home has never loaded on this device. Nothing to ask is the
 * right answer then: the alert still raises, and the card asks everything a
 * second later exactly as it did before round 0 existed.
 */
export function preRaiseFor(
  home: OperatorHomeVM | undefined,
  type: AlertTypeKey | null,
  hasPod: boolean,
): PreRaiseQuestion[] {
  if (!type || !home?.ask) return [];
  return (hasPod ? home.ask.withPod : home.ask.withoutPod)[type] ?? [];
}

/**
 * "When will this stop the line?", from home, or null.
 *
 * The same question for every tile, so the server sends it once rather than
 * duplicating it into twenty sets — and the CARD decides whether to ask it,
 * because it holds the severity. The words and the chips are still the
 * server's, so there is nothing for the two to drift about.
 */
export function stopInQuestion(home: OperatorHomeVM | undefined): PreRaiseQuestion | null {
  return home?.ask?.stopIn ?? null;
}
